import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/messages").then(r => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-messages">
      <h1 className="font-display text-3xl text-[color:var(--color-primary)] mb-8">Messages</h1>
      <div className="space-y-4">
        {items.length === 0 && <div className="text-gray-500 text-sm">No messages yet.</div>}
        {items.map((m) => (
          <div key={m.id} className="bg-white border border-[color:var(--color-border)] rounded p-5" data-testid={`message-${m.id}`}>
            <div className="flex justify-between items-start">
              <div>
                <div className="font-medium">{m.name}</div>
                <div className="text-xs text-gray-500">{m.email} · {m.phone}</div>
              </div>
              <div className="text-xs text-gray-500">{(m.created_at || "").split("T")[0]}</div>
            </div>
            {m.subject && <div className="font-medium mt-3">{m.subject}</div>}
            <div className="text-sm text-[color:var(--color-text-secondary)] mt-2">{m.message}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
